import React, { Component } from 'react';
import './style';

class ParallaxBackground extends Component {
  constructor(props) {
    super(props);
    this.canvas = null;
    this.animFrame = null;
  }

  componentDidMount() {
    this.ctx = this.canvas.getContext('2d');
    this.draw();
    window.addEventListener('resize', this.draw);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.draw);
  }

  draw = () => {
    const canvas = this.canvas;
    const ctx = this.ctx;
    const W = canvas.width = window.innerWidth;
    const H = canvas.height = window.innerHeight;

    ctx.fillStyle = '#050208';
    ctx.fillRect(0, 0, W, H);

    ctx.fillStyle = 'rgba(0,0,0,0.18)';
    for (let y = 0; y < H; y += 4) {
      ctx.fillRect(0, y, W, 1);
    }

    const bloom = ctx.createRadialGradient(W / 2, H / 2, 0, W / 2, H / 2, W * 0.35);
    bloom.addColorStop(0, 'rgba(124,58,171,0.06)');
    bloom.addColorStop(0.5, 'rgba(124,58,171,0.02)');
    bloom.addColorStop(1, 'rgba(124,58,171,0)');
    ctx.fillStyle = bloom;
    ctx.fillRect(0, 0, W, H);

    const vig = ctx.createRadialGradient(W / 2, H / 2, H * 0.2, W / 2, H / 2, H * 0.9);
    vig.addColorStop(0, 'rgba(0,0,0,0)');
    vig.addColorStop(1, 'rgba(0,0,0,0.75)');
    ctx.fillStyle = vig;
    ctx.fillRect(0, 0, W, H);
  }

  render() {
    return <canvas ref={(el) => { this.canvas = el; }} className="parallax" />;
  }
}

export default ParallaxBackground;



// WEBPACK FOOTER //
// ./src/components/ParallaxBackground/ParallaxBackground.js